import { useLocation, useNavigate } from 'react-router-dom';

import useSearchParams from 'common/hooks/useSearchParams';

export default (defaultTab, tabs = [], resetParams = true, queryParamName = 'tab') => {
  const navigate = useNavigate();
  const location = useLocation();

  const query = useSearchParams();

  const active = tabs.includes(query.get(queryParamName)) ? query.get(queryParamName) : defaultTab;

  const onChange = key => {
    const newTab = tabs.includes(key) ? key : defaultTab;

    if (active !== newTab) {
      if (resetParams) {
        // when set to true, `resetParams` will make sure to remove all the other query params
        navigate({ ...location, search: `?${queryParamName}=${newTab}` }, { replace: true });

        return;
      }

      query.set(queryParamName, newTab);
      query.sort();

      navigate({ ...location, search: query.toString() }, { replace: true });
    }
  };

  return [active, onChange];
};
